<template>
  <v-app>

    <v-app-bar
      id="default-app-bar"
      app
      absolute
      class="v-bar--underline header-bar"
      color="transparent"
      height="70"
      flat
    >
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />

      <div class="hidden-sm-and-down">
      <v-btn
        class="ml-3 mr-4"
        elevation="1"
        fab
        small
        @click="mini = !mini"
      >
        <v-icon>
          {{ mini ? 'mdi-format-list-bulleted' : 'mdi-dots-vertical' }}
        </v-icon>
      </v-btn>
      </div>

      <v-toolbar-title
        class="font-weight-light text-h5"
        v-text="name"
      />

      <v-spacer></v-spacer>

      <v-menu
        bottom
        left
        min-width="200"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ml-2"
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list
          :tile="false"
          nav
        >
          <template v-for="(p, i) in profile">
            <v-divider
              v-if="p.divider"
              :key="`divider-${i}`"
              class="mb-2 mt-2"
            />

            <v-list-item
              link
              v-else-if="p.logout"
              :key="`item-${i}`"
              @click="logout"
            >
              <v-list-item-title v-text="p.title"></v-list-item-title>
            </v-list-item>

            <v-list-item
              link
              v-else
              :key="`item-${i}`"
              :to="p.to"
            >
              <v-list-item-title v-text="p.title"></v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      id="default-drawer"
      v-model="drawer"
      :mini-variant.sync="mini"
      mini-variant-width="80"
      app
      src="https://dataenergy.co.uk/wp-content/uploads/2021/03/footer-element-testing.png"
      width="260"
      dark
      class="darker side-bar"
    >

      <div class="px-0">

        <div class="pa-4" v-if="!mini">
          <v-img contain min-height="80" src="../../assets/de-logo-white_no_line.png"></v-img>
        </div>
        <div class="pa-4" v-if="mini">
          <v-img contain min-height="80" src="../../assets/data-energy-logo-white-crop.png"></v-img>
        </div>

        <v-list-item class="mt-5" v-if="!mini">
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              Welcome {{ firstName.firstName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>




        <v-divider class="mx-3 mb-2" />

        <v-list
          expand
          nav
        >

          <v-list-item
            v-for="(item, i) in navigation"
            :key="i"
            :href="item.href"
            :rel="item.href ? 'nofollow' : undefined"
            :target="item.href ? '_blank' : undefined"
            :to="item.to"
            active-class="primary white--text"
            link
            class="py-0"
          >
            <v-list-item-icon
              v-if="!item.icon"
              class="text-caption text-uppercase justify-center ml-1 my-2 align-self-center"
            >
              {{ title }}
            </v-list-item-icon>

            <v-list-item-avatar v-if="item.avatar">
              <v-img :src="item.avatar" />
            </v-list-item-avatar>

            <v-list-item-icon
              v-if="item.icon"
              class="my-0 align-self-center"
            >
              <v-icon v-text="item.icon" />
            </v-list-item-icon>

            <v-list-item-content v-if="item.title">
              <v-list-item-title v-text="item.title" />
            </v-list-item-content>
          </v-list-item>

        </v-list>

        <v-divider class="mx-3 mb-2" />

        <v-list
          expand
          nav
        >

          <v-list-item
            v-for="(item, i) in extraNavigation"
            :key="i"
            :href="item.href"
            :rel="item.href ? 'nofollow' : undefined"
            :target="item.href ? '_blank' : undefined"
            :to="item.to"
            active-class="primary white--text"
            link
            class="py-0"
          >
            <v-list-item-icon
              v-if="!item.icon"
              class="text-caption text-uppercase justify-center ml-1 my-2 align-self-center"
            >
              {{ title }}
            </v-list-item-icon>

            <v-list-item-avatar v-if="item.avatar">
              <v-img :src="item.avatar" />
            </v-list-item-avatar>

            <v-list-item-icon
              v-if="item.icon"
              class="my-0 align-self-center"
            >
              <v-icon v-text="item.icon" />
            </v-list-item-icon>

            <v-list-item-content v-if="item.title">

                <v-list-item-title v-text="item.title" />


            </v-list-item-content>
          </v-list-item>

        </v-list>

        <v-divider v-if="firstName.isThirdParty" class="mx-3 mb-2" />

        <v-list
          v-if="firstName.isThirdParty"
          expand
          nav
        >

          <v-list-item
            active-class="primary white--text"
            link
            class="py-0"
            @click="utilityClick"
          >

            <v-list-item-icon
              class="my-0 align-self-center"
            >
              <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>

              <v-list-item-title>Access Utility Click</v-list-item-title>


            </v-list-item-content>
          </v-list-item>

        </v-list>

      </div>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block v-if="!mini">
            Logout
          </v-btn>
          <v-btn @click="logout" block v-else>
            <v-icon
              dark
              right
            >
              mdi-logout
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>

      <v-container fluid>
        <router-view :key="$route.path" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { get, sync } from 'vuex-pathify';

export default {
  name: "MainLayout",
  computed: {
    ...sync('app', [
      'drawer',
      'mini',
    ]),
    name: get('route/name'),
    firstName: get('auth/user'),
    navigation:get('app/navItems'),
    extraNavigation:get('app/additionalNav')
  },
  data: () => ({
    profile: [
      { title: 'Account & Security', to: "/user" },
      { title: 'My Downloads', to: "/downloads" },
      { divider: true },
      { title: 'Log out', logout: true },
    ],
  }),
  methods: {
    async logout() {
      const loggedOut = await this.$store.dispatch("auth/logout");

      if (loggedOut) {
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Successfully logged out" });
        await this.$router.push("/login");
      }
    },
    async utilityClick() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Please wait. Redirecting to Utility Click" });

      const thirdParty = await this.$store.dispatch("auth/requestThirdParty");

      if (!thirdParty.otp) {
        await this.$store.dispatch("loader/loaderCancel");
        return;
      }

      window.location.href = process.env.VUE_APP_UTILITY_CLICK_PATH + "?email=" + thirdParty.account + "&code=" + thirdParty.otp;

    },
  }
}
</script>

<style lang="scss" scoped>
#default-drawer {
  color: #83c55d;
  padding: 5px;
  height: 100% !important;
}

.header-bar {
  z-index: 0 !important;
}

</style>
